export default __webpack_public_path__ + "static/media/placeholder_dummy2016-grafikdesigner01-de.444c3023.png";